module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTgwMCA2NGEzMiAzMiAwIDAgMSAzMiAzMnY4MzJhMzIgMzIgMCAwIDEtMzIgMzJIMjI0YTMyIDMyIDAgMCAxLTMyLTMyVjk2YTMyIDMyIDAgMCAxIDMyLTMyaDU3NnogbS0xNTguNiAxMTNhMzIgMzIgMCAwIDEtMjcuMSAxNWgtMjA0LjVhMzIgMzIgMCAwIDEtMjcuMS0xNUwzNTIgMTI4SDI1NnY3NjhoNTEyVjEyOGgtOTZsLTMwLjYgNDl6TTY0MCA4MDBhMzIgMzIgMCAwIDEgMCA2NGgtMjU2YTMyIDMyIDAgMCAxIDAtNjRoMjU2eiIgZmlsbD0iIzAiIHAtaWQ9IjIwOTQiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Mobile-outlined.svg
// module id = ymts
// module chunks = 75